export const normalizeAdminPathname = (pathname = "/") => {
  const normalized = String(pathname || "/").replace(/\/+$/, "");
  return normalized || "/";
};

export const canOpenQuickAssessmentResults = (session) =>
  session?.admin?.authorized === true && session?.admin?.role === "owner";
